import Resource from './resource';

export default class SessionResource extends Resource{
	constructor(){
		super('sessions');
	}
}